module.exports = __webpack_public_path__ + "static/gallery-1-3fa58ff12996cae8e35ad5d650ca4f95.jpg";